import React, { useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import useRevealOnScroll from "../../general/components/common/useRevealOnScroll";
import { cursos } from "../assets/InfoCursos";
import { generalFaqGroups } from "../assets/faqData";
import useCatalogFilter from "../components/useCatalogFilter";
import conoceFispVideo from "../assets/media/vid/conoce-fisp.mp4";
import video1Preview from "../assets/media/img/video-1-preview.png";
import video2Preview from "../assets/media/img/video-2-preview.png";
import video3Preview from "../assets/media/img/video-3-preview.png";
import aletStaff from "../assets/media/img/staff/Alet.jpg";
import carchiniStaff from "../assets/media/img/staff/carchini.jpg";
import dadicStaff from "../assets/media/img/staff/Dadic.png";
import deVicentiisStaff from "../assets/media/img/staff/DeVicentiis.png";
import diazStaff from "../assets/media/img/staff/diaz.jpeg";
import diegoSlipakStaff from "../assets/media/img/staff/DSlipak.png";
import eneiStaff from "../assets/media/img/staff/Enei.jpg";
import faustoStaff from "../assets/media/img/staff/Fausto.png";
import lanzaStaff from "../assets/media/img/staff/Lanza.jpg";
import laurettaStaff from "../assets/media/img/staff/Lauretta.jpg";
import manfrediStaff from "../assets/media/img/staff/Manfredi.png";
import pastorStaff from "../assets/media/img/staff/Pastor.png";
import pederneraStaff from "../assets/media/img/staff/Pedernera.jpg";
import pingitoreStaff from "../assets/media/img/staff/Pingitore.png";
import slipakStaff from "../assets/media/img/staff/Slipak.png";
import zarebaStaff from "../assets/media/img/staff/Zareba.jpg";

const utf8Decoder = new TextDecoder("utf-8");
const educationalVideosContext = require.context("../assets/media/vid", false, /\.mp4$/);

const areaFilters = [
    { key: "all", label: "Todas las áreas" },
    { key: "dermatologia", label: "Dermatología" },
    { key: "nutricion", label: "Nutrición" },
    { key: "psiquiatria", label: "Psiquiatría" },
    { key: "tecnologia", label: "Tecnología" },
    { key: "enfermeria", label: "Enfermería" },
    { key: "criminalistica", label: "Criminalística" },
    { key: "salud-mental-y-adicciones", label: "Salud mental y Adicciones" },
    { key: "marketing", label: "Marketing" },
    { key: "emergencias", label: "Emergencias" },
    { key: "medicina-laboral", label: "Medicina Laboral" },
    { key: "neurologia", label: "Neurología" },
    { key: "medicina-de-precision", label: "Medicina de Precisión" },
    { key: "ginecologia", label: "Ginecología" },
];

const hiddenAreaFilters = new Set(["psiquiatria", "medicina-de-precision"]);
const visibleAreaFilters = areaFilters.filter((filter) => !hiddenAreaFilters.has(filter.key));
const areaFilterKeys = new Set(visibleAreaFilters.filter((filter) => filter.key !== "all").map((filter) => filter.key));

const typeOrder = {
    Posgrado: 0,
    Diplomatura: 1,
    Curso: 2,
};

const legacyStaffPreview = [
    { initials: "RF", name: "Dr. Rodrigo Fernández", title: "Director Académico · Medicina Interna" },
    { initials: "MA", name: "Dra. Mariana Acosta", title: "Coordinadora · Nutrición Clínica" },
    { initials: "LS", name: "Lic. Lucas Serrano", title: "Docente · Tecnología e IA en Salud" },
    { initials: "PG", name: "Dra. Paula Gómez", title: "Docente · Dermatología Estética" },
    { initials: "JM", name: "Dr. Juan Morales", title: "Docente · Toxicología Médica" },
    { initials: "VR", name: "Lic. Valeria Ríos", title: "Docente · Salud Mental y TCA" },
    { initials: "CB", name: "Dr. Carlos Benítez", title: "Docente · Emergencias y Urgencias" },
    { initials: "AI", name: "Dra. Andrea Ibáñez", title: "Coordinadora · Diplomatura Skincare" },
    { initials: "MP", name: "Dr. Martín Ponce", title: "Docente · Gestión Sanitaria" },
    { initials: "SL", name: "Lic. Sofía Leal", title: "Docente · Enfermería Avanzada" },
    { initials: "FO", name: "Dr. Federico Ortega", title: "Docente · Big Data en Salud" },
    { initials: "NV", name: "Dra. Natalia Vera", title: "Docente · Nutrición Deportiva" },
];

void legacyStaffPreview;

const staffPreview = [
    { initials: "PL", name: "Dr. Paolo Lauretta", title: "Director de Salud Digital", photo: laurettaStaff },
    { initials: "DS", name: "Dr. Diego Slipak", title: "Director Académico", photo: diegoSlipakStaff },
    { initials: "SP", name: "Dra. Sylvia Pingitore", title: "Directora de Dermatología", photo: pingitoreStaff },
    { initials: "JC", name: "Dr. Juan Ignacio Carchini", title: "Director Médico", photo: carchiniStaff },
    { initials: "FP", name: "Dr. Federico Agustín Pedernera", title: "Director del Hub de Innovación y Tecnología Digital en Salud", photo: pederneraStaff },
    { initials: "EM", name: "Dra. Elena Pastor Manfredi", title: "Directora de Nutrición", photo: manfrediStaff },
    { initials: "AR", name: "Dr. Alfredo Ruíz Díaz", title: "Director de Medicina Estética y Regenerativa", photo: diazStaff },
    { initials: "CE", name: "Dra. Camila Enei", title: "Directora de Ginecología", photo: eneiStaff },
    { initials: "SF", name: "Dr. Sergio Adrián Fausto", title: "Director de Deportología y Traumatología", photo: faustoStaff },
    { initials: "FD", name: "Dr. Francisco Dadic", title: "Director de Toxicología", photo: dadicStaff },
    { initials: "OS", name: "Dr. Óscar Eduardo Slipak", title: "Director de Psiquiatría", photo: slipakStaff },
    { initials: "RP", name: "Dr. Raul Pastor", title: "Director de Calidad de vida", photo: pastorStaff },
    { initials: "NZ", name: "Dra. Natalia Zareba", title: "Directora de Cardiología", photo: zarebaStaff },
    { initials: "MA", name: "Dr. Matías Alet", title: "Director de Neurología", photo: aletStaff },
    { initials: "JL", name: "Lic. Juliana Lanza", title: "Directora de Psicología", photo: lanzaStaff },
];

const visibleStaffPreview = [
    ...staffPreview.filter((person) => person.name !== "Dra. Natalia Zareba"),
    {
        initials: "LV",
        name: "Lic. Leonardo de Vincentiis",
        title: "Director de Enfermeria",
        photo: deVicentiisStaff,
    },
];

function resolveEducationalVideo(fileName) {
    try {
        return educationalVideosContext(`./${fileName}`);
    } catch {
        return conoceFispVideo;
    }
}

const educationalVideoCards = [
    {
        id: "video-1",
        title: "La importancia de la tecnología para una educación de vanguardia",
        src: resolveEducationalVideo("video-1.mp4"),
        poster: video1Preview,
        posterGradient: "linear-gradient(135deg, #203456, #36527d 52%, #8ba9d3)",
    },
    {
        id: "video-2",
        title: "Los desafios de la nutrición actual",
        src: resolveEducationalVideo("video-2.mp4"),
        poster: video2Preview,
        posterGradient: "linear-gradient(135deg, #4d3a2e, #87654b 54%, #d3b18c)",
    },
    {
        id: "video-3",
        title: "La necesidad de médicos formados en Big Data",
        src: resolveEducationalVideo("video-3.mp4"),
        poster: video3Preview,
        posterGradient: "linear-gradient(135deg, #253640, #2f5e69 56%, #7fb7c4)",
    },
];

function EducationalVideoCard({ item }) {
    const [shouldLoad, setShouldLoad] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const videoRef = useRef(null);

    const handleStart = () => {
        if (shouldLoad) {
            return;
        }

        setShouldLoad(true);
    };

    const handleReady = () => {
        setIsReady(true);
        videoRef.current?.play?.().catch(() => {
            // Ignore autoplay rejection after the user initiated playback.
        });
    };

    return (
        <div className={`vid-card${shouldLoad ? " is-loading" : ""}${isReady ? " is-ready" : ""}`}>
            <div className="vid-card-thumb">
                {shouldLoad ? (
                    <video
                        ref={videoRef}
                        className="vid-card-video"
                        src={item.src}
                        controls
                        preload="none"
                        poster={item.poster}
                        playsInline
                        autoPlay
                        onLoadedData={handleReady}
                        onCanPlay={handleReady}
                        aria-label={item.title}
                    >
                        Tu navegador no soporta video HTML5.
                    </video>
                ) : null}

                <div
                    className={`vid-card-poster${isReady ? " is-hidden" : ""}`}
                    style={
                        item.poster
                            ? {
                                backgroundImage: `url(${item.poster})`,
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                            }
                            : { background: item.posterGradient }
                    }
                >
                    <button
                        type="button"
                        className={`vid-card-play${shouldLoad ? " is-hidden" : ""}`}
                        onClick={handleStart}
                        aria-label={`Reproducir ${item.title}`}
                        aria-hidden={shouldLoad}
                        tabIndex={shouldLoad ? -1 : 0}
                    >
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <polygon points="5 3 19 12 5 21"></polygon>
                        </svg>
                    </button>

                    {shouldLoad && !isReady ? <span className="vid-card-loading">Cargando video...</span> : null}

                </div>
            </div>
            <div className="vid-card-body">
                <span className="tag-sm">Video</span>
                <h4>{item.title}</h4>
            </div>
        </div>
    );
}

function getProgramType(program) {
    return (program.tipo || "").toLowerCase();
}

function getProgramAreas(program) {
    const categories = Array.isArray(program.categoria) ? program.categoria : [];

    return categories.filter((category) => areaFilterKeys.has(category));
}

function getProgramLink(program) {
    return `/${program.routeFamily}/${program.routeSlug}`;
}

function BadgeIcon({ name, color }) {
    const iconProps = {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: 1.9,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
    };
    const icons = {
        academic: (
            <>
                <path d="M3.5 8.5 12 4l8.5 4.5L12 13 3.5 8.5Z" />
                <path d="M7 10.5v4.2c0 .9 2.2 2.3 5 2.3s5-1.4 5-2.3v-4.2" />
                <path d="M20.5 8.7v5.8" />
                <path d="M20.5 14.5c-.8 0-1.5.7-1.5 1.5v1h3v-1c0-.8-.7-1.5-1.5-1.5Z" />
            </>
        ),
        online: (
            <>
                <path d="M6.3 5.5h11.4a1.2 1.2 0 0 1 1.2 1.2v7.3H5.1V6.7a1.2 1.2 0 0 1 1.2-1.2Z" />
                <path d="M3.5 16.2h17" />
                <path d="m5.1 16.2 1 2.3h11.8l1-2.3" />
                <path d="M10.1 18h3.8" />
                <path d="M11.8 6.9h.4" />
            </>
        ),
        global: (
            <>
                <circle cx="12" cy="12" r="8.5" />
                <path d="M12 3.5c2.4 2.3 3.8 5.2 3.8 8.5S14.4 18.2 12 20.5" />
                <path d="M12 3.5c-2.4 2.3-3.8 5.2-3.8 8.5s1.4 6.2 3.8 8.5" />
                <path d="M4 9h16" />
                <path d="M4 15h16" />
            </>
        ),
        science: (
            <>
                <path d="M8 4v5a4 4 0 0 0 8 0V4" />
                <path d="M8 4H6.7" />
                <path d="M16 4h1.3" />
                <path d="M12 13v2.6a3.5 3.5 0 0 0 7 0v-1.2" />
                <circle cx="18.7" cy="13.9" r="1.8" />
            </>
        ),
    };

    return <svg {...iconProps}>{icons[name]}</svg>;
}

function normalizeSpanishText(value) {
    if (typeof value !== "string" || !/[ÃÂâ]/.test(value)) {
        return value || "";
    }

    let nextValue = value;

    for (let index = 0; index < 2; index += 1) {
        if (!/[ÃÂâ]/.test(nextValue)) {
            break;
        }

        try {
            nextValue = utf8Decoder.decode(Uint8Array.from(nextValue, (character) => character.charCodeAt(0)));
        } catch {
            break;
        }
    }

    return nextValue;
}

function getProgramTitle(program) {
    return normalizeSpanishText(program.nombre || "")
        .replace(/^Posgrado en\s+/i, "")
        .replace(/^Diplomatura en\s+/i, "")
        .replace(/^Curso de\s+/i, "");
}

function getProgramDescription(program) {
    return normalizeSpanishText(program.descripcionPreview || program.descripcion || "").trim();
}

function getProgramMeta(program) {
    if (program.duracion) {
        return `${program.duracion} ${program.duracion === 1 ? "mes" : "meses"}`;
    }

    if (program.clases) {
        return `${program.clases} ${program.clases === 1 ? "clase" : "clases"}`;
    }

    if (program.modalidad) {
        return normalizeSpanishText(program.modalidad);
    }

    return "Inscripciones abiertas";
}

const catalogPrograms = [...cursos]
    .sort((leftProgram, rightProgram) => {
        const typeDifference = (typeOrder[leftProgram.tipo] ?? 99) - (typeOrder[rightProgram.tipo] ?? 99);

        if (typeDifference !== 0) {
            return typeDifference;
        }

        const soldOutDifference =
            Number(Boolean(leftProgram.cuposLlenos)) -
            Number(Boolean(rightProgram.cuposLlenos));

        if (soldOutDifference !== 0) {
            return soldOutDifference;
        }

        return leftProgram.nombre.localeCompare(rightProgram.nombre, "es", { sensitivity: "base" });
    })
    .map((program) => ({
        ...program,
        cardType: getProgramType(program),
        cardAreas: getProgramAreas(program),
        cardLink: getProgramLink(program),
        cardTitle: getProgramTitle(program),
        cardDescription: getProgramDescription(program),
        cardMeta: getProgramMeta(program),
    }));

const programCounts = catalogPrograms.reduce(
    (counts, program) => ({
        ...counts,
        [program.cardType]: (counts[program.cardType] || 0) + 1,
    }),
    { all: catalogPrograms.length, posgrado: 0, diplomatura: 0, curso: 0 },
);

export default function Educativo() {
    const pageRef = useRef(null);
    const heroVideoRef = useRef(null);
    const [searchParams] = useSearchParams();
    const [isHeroVideoStarted, setIsHeroVideoStarted] = useState(false);
    const [openFaqId, setOpenFaqId] = useState(null);
    const requestedCategory = searchParams.get("categoria");
    const initialCatalogCategory = ["posgrado", "diplomatura", "curso"].includes(requestedCategory) ? requestedCategory : "posgrado";
    const shouldScrollToCatalog = searchParams.get("scroll") === "catalogo";
    const staffTrack = [...visibleStaffPreview, ...visibleStaffPreview];

    useRevealOnScroll(pageRef);
    useCatalogFilter(pageRef, {
        initialType: initialCatalogCategory,
        initialArea: "all",
        scrollTargetId: shouldScrollToCatalog ? "catalogo" : null,
        scrollExtraOffset: shouldScrollToCatalog ? 144 : 0,
    });

    const handleHeroVideoStart = async () => {
        setIsHeroVideoStarted(true);

        try {
            await heroVideoRef.current?.play();
        } catch {
            // Keep controls visible even if playback is blocked after the user click.
        }
    };

    const toggleFaq = (faqId) => {
        setOpenFaqId((currentFaqId) => (currentFaqId === faqId ? null : faqId));
    };

    return (
        <div className="educativo" ref={pageRef}>
            <SiteNavbar activeSection="educativo" />
            <section className="hero-section">
                <div className="ph-inner">
                    <div className="breadcrumb">
                        <Link to="/">Inicio</Link> <span className="sep">→</span>{" "}
                        <span
                            style={{
                                color: "rgba(255,255,255,.7)",
                            }}
                        >
                            FISP Educativo
                        </span>
                    </div>
                    <div className="ph-grid">
                        <div>
                            <h1>
                                Formación en salud con <span>respaldo universitario</span>
                            </h1>
                            <p>
                                Posgrados, diplomaturas y cursos diseñados por profesionales del sector salud, con doble titulación FISP y Facultad de Medicina de la Universidad de
                                Buenos Aires.
                            </p>
                            <div className="ph-stats">
                                <div className="ph-stat">
                                    <div className="ph-stat-n">{programCounts.posgrado}</div>
                                    <div className="ph-stat-l">Posgrados</div>
                                </div>
                                <div className="ph-stat">
                                    <div className="ph-stat-n">{programCounts.diplomatura}</div>
                                    <div className="ph-stat-l">Diplomaturas</div>
                                </div>
                                <div className="ph-stat">
                                    <div className="ph-stat-n">{programCounts.curso}</div>
                                    <div className="ph-stat-l">Cursos</div>
                                </div>
                            </div>
                        </div>
                        <div className="ph-video">
                            <video ref={heroVideoRef} className="ph-video-media" src={conoceFispVideo} controls={isHeroVideoStarted} playsInline preload="metadata">
                                Tu navegador no soporta video HTML5.
                            </video>
                            <button
                                type="button"
                                className={`play ${isHeroVideoStarted ? "is-hidden" : ""}`}
                                onClick={handleHeroVideoStart}
                                aria-label="Reproducir video introductorio de FISP Educativo"
                                aria-hidden={isHeroVideoStarted}
                                tabIndex={isHeroVideoStarted ? -1 : 0}
                            >
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <polygon points="5 3 19 12 5 21"></polygon>
                                </svg>
                            </button>
                            <span className={`ph-video-label ${isHeroVideoStarted ? "is-hidden" : ""}`}>Conocé FISP Educativo · 1:00</span>
                        </div>
                    </div>
                </div>
            </section>
            <section className="inst-section reveal">
                <div className="inst-inner">
                    <div>
                        <h2>Formamos profesionales con los más altos estándares académicos y tecnológicos</h2>
                        <p>
                            La Fundación Iberoamericana de Salud Pública es una organización de la sociedad civil sin fines de lucro cuyo objetivo principal es formar profesionales
                            capacitados para los desafíos actuales del sector salud.
                        </p>
                        <p>
                            La tecnología está revolucionando el sector sanitario desarrollando soluciones eficientes para la atención en salud que requieren de recursos humanos
                            capacitados.
                        </p>
                        <div className="highlight-box">
                            <p>
                                Nuestros programas integran docencia, asistencia e investigación con el criterio de creatividad, innovación y conocimiento, promoviendo la equidad en
                                salud.
                            </p>
                        </div>
                    </div>
                    <div className="inst-badges">
                        <div className="inst-badge">
                            <div
                                className="inst-badge-ico"
                                style={{
                                    background: "#fde5ea",
                                }}
                            >
                                <BadgeIcon name="academic" color="#b91c1c" />
                            </div>
                            <div>
                                <h4>Doble titulación</h4>
                                <p>FISP y Facultad de Medicina de la Universidad de Buenos Aires.</p>
                            </div>
                        </div>
                        <div className="inst-badge">
                            <div
                                className="inst-badge-ico"
                                style={{
                                    background: "#dbeafe",
                                }}
                            >
                                <BadgeIcon name="online" color="#2563eb" />
                            </div>
                            <div>
                                <h4>100% online</h4>
                                <p>Clases en vivo y asincrónicas en nuestro campus virtual</p>
                            </div>
                        </div>
                        <div className="inst-badge">
                            <div
                                className="inst-badge-ico"
                                style={{
                                    background: "#d1fae5",
                                }}
                            >
                                <BadgeIcon name="global" color="#059669" />
                            </div>
                            <div>
                                <h4>Alcance Internacional</h4>
                                <p>Alumnos en más de 12 países: Argentina, Colombia, Chile, México, Perú, Uruguay y más.</p>
                            </div>
                        </div>
                        <div className="inst-badge">
                            <div
                                className="inst-badge-ico"
                                style={{
                                    background: "#fde68a",
                                }}
                            >
                                <BadgeIcon name="science" color="#b45309" />
                            </div>
                            <div>
                                <h4>Docentes especializados</h4>
                                <p>Profesionales con antecedentes académicos, científicos y operativos en el sector salud.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="catalog-section" id="catalogo">
                <div className="cat-inner">
                    <div className="cat-head reveal">
                        <div>
                            <h2>Explorá toda la oferta educativa</h2>
                            <p>{programCounts.all} programas activos · Inscripciones abiertas 2026</p>
                        </div>
                    </div>
                    <div className="cat-tabs reveal" id="tabs">
                        <span className={`cat-tab ${initialCatalogCategory === "posgrado" ? "active" : ""}`} data-filter="posgrado">
                            Posgrados ({programCounts.posgrado})
                        </span>
                        <span className={`cat-tab ${initialCatalogCategory === "diplomatura" ? "active" : ""}`} data-filter="diplomatura">
                            Diplomaturas ({programCounts.diplomatura})
                        </span>
                        <span className={`cat-tab ${initialCatalogCategory === "curso" ? "active" : ""}`} data-filter="curso">
                            Cursos ({programCounts.curso})
                        </span>
                    </div>
                    <div className="cat-filters reveal" id="filters">
                        {visibleAreaFilters.map((filter) => (
                            <span key={filter.key} className={`cat-filter ${filter.key === "all" ? "active" : ""}`} data-area={filter.key}>
                                {filter.label}
                            </span>
                        ))}
                    </div>
                    <div className="cat-grid" id="catalog">
                        {catalogPrograms.map((program) => (
                            <Link key={program.id} to={program.cardLink} className="c-card" data-type={program.cardType} data-area={program.cardAreas.join(" ")}>
                                <div className="c-card-top">
                                    {program.cuposLlenos ? (
                                        <span className="badge badge-red">Cupos llenos</span>
                                    ) : null}
                                    {program.foto ? <img className="c-card-cover" src={program.foto} alt={program.cardTitle} loading="lazy" /> : <div className="bg g1"></div>}
                                </div>
                                <div className="c-card-body">
                                    <span className="type">{program.tipo}</span>
                                    <h3>{program.cardTitle}</h3>
                                    <p>{program.cardDescription}</p>
                                    <div className="c-meta">
                                        <span>
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10"></circle>
                                                <path d="M12 6v6l4 2"></path>
                                            </svg>
                                            {program.cardMeta}
                                        </span>
                                        {["posgrado", "diplomatura"].includes(program.cardType) ? (
                                            <span>Certificado FISP + UBA</span>
                                        ) : null}
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
            {/* Sección guardada para implementación futura.
            <section className="video-section reveal">
                <div className="vid-inner">
                    <div className="vid-head">
                        <span>Desde el campus</span>
                        <h2>Conocé a nuestros docentes y alumnos</h2>
                        <p>Entrevistas, clases abiertas y testimonios de quienes forman parte de FISP Educativo.</p>
                    </div>
                    <div className="vid-grid">
                        <div className="vid-card">
                            <div className="vid-card-thumb">
                                <div className="bg g1"></div>
                                <span className="play-sm">
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <polygon points="5 3 19 12 5 21"></polygon>
                                    </svg>
                                </span>
                            </div>
                            <div className="vid-card-body">
                                <span className="tag-sm">Clase abierta</span>
                                <h4>Introducción a la IA Médica</h4>
                                <p>Dr. Federico Pedernera · 45 min</p>
                            </div>
                        </div>
                        <div className="vid-card">
                            <div className="vid-card-thumb">
                                <div className="bg g5"></div>
                                <span className="play-sm">
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <polygon points="5 3 19 12 5 21"></polygon>
                                    </svg>
                                </span>
                            </div>
                            <div className="vid-card-body">
                                <span className="tag-sm">Entrevista</span>
                                <h4>Nutrición y microbiota: lo que sabemos hoy</h4>
                                <p>FISP TV · 20 min</p>
                            </div>
                        </div>
                        <div className="vid-card">
                            <div className="vid-card-thumb">
                                <div className="bg g7"></div>
                                <span className="play-sm">
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <polygon points="5 3 19 12 5 21"></polygon>
                                    </svg>
                                </span>
                            </div>
                            <div className="vid-card-body">
                                <span className="tag-sm">Testimonio</span>
                                <h4>"FISP cambió mi carrera profesional"</h4>
                                <p>Egresados 2025 · 8 min</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="staff-section reveal">
                <div className="staff-inner">
                    <div className="staff-head">
                        <span>Nuestro equipo</span>
                        <h2>Docentes y profesionales especializados</h2>
                        <p>La Fundación Iberoamericana de Salud Pública está integrada por un equipo altamente calificado y comprometido, dedicado a brindar información de calidad.</p>
                    </div>
                </div>
                <div className="staff-track-shell">
                    <div className="staff-track">
                        {staffTrack.map((person, index) => (
                            <article
                                key={`${person.initials}-${person.name}-${index}`}
                                className="staff-card"
                                aria-hidden={index >= visibleStaffPreview.length}
                            >
                                <div className="staff-avatar">
                                    {person.photo ? <img src={person.photo} alt={person.name} loading="lazy" /> : person.initials}
                                </div>
                                <h3>{person.name}</h3>
                                <p>{person.title}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
            <section className="video-section reveal">
                <div className="vid-inner">
                    <div className="vid-head">
                        <span>Desde el campus</span>
                        <h2>Conoce a nuestros docentes</h2>
                        <p>Entrevistas, clases abiertas y testimonios de quienes forman parte de FISP Educativo.</p>
                    </div>
                    <div className="vid-grid">
                        {educationalVideoCards.map((item) => (
                            <EducationalVideoCard key={item.id} item={item} />
                        ))}
                    </div>
                </div>
            </section>
            <section className="test-section reveal">
                <div className="test-inner">
                    <div className="test-head">
                        <span>Testimonios</span>
                        <h2>Lo que dicen nuestros alumnos</h2>
                    </div>
                    <div className="test-grid">
                        <div className="t-card">
                            <div className="stars">★★★★★</div>
                            <p className="quote">La diplomatura en TCA me dio herramientas concretas para el abordaje interdisciplinario. Excelente nivel de docentes y casos reales.</p>
                            <div className="author">
                                <div
                                    className="av"
                                    style={{
                                        background: "var(--red)",
                                    }}
                                >
                                    ML
                                </div>
                                <div>
                                    <h4>Lic. Mariana López</h4>
                                    <p>Nutricionista · Buenos Aires</p>
                                </div>
                            </div>
                        </div>
                        <div className="t-card">
                            <div className="stars">★★★★★</div>
                            <p className="quote">Cursé desde Colombia la Diplomatura en Skincare. La plataforma virtual es muy buena y los contenidos están súper actualizados.</p>
                            <div className="author">
                                <div
                                    className="av"
                                    style={{
                                        background: "#2563EB",
                                    }}
                                >
                                    CR
                                </div>
                                <div>
                                    <h4>Dra. Carolina Restrepo</h4>
                                    <p>Cosmiatra · Bogotá, Colombia</p>
                                </div>
                            </div>
                        </div>
                        <div className="t-card">
                            <div className="stars">★★★★★</div>
                            <p className="quote">El título con respaldo UBA le dio otro peso a mi CV. Los módulos de IA Médica son de lo mejor que vi en formación online.</p>
                            <div className="author">
                                <div
                                    className="av"
                                    style={{
                                        background: "#059669",
                                    }}
                                >
                                    FP
                                </div>
                                <div>
                                    <h4>Dr. Federico Pérez</h4>
                                    <p>Médico clínico · CABA</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="faq-section reveal">
                <div className="faq-inner">
                    <div className="faq-head">
                        <span>FAQ</span>
                        <h2>Preguntas frecuentes</h2>
                        <p>Respuestas a las consultas más comunes.</p>
                    </div>
                    <div className="faq-accordion">
                        {generalFaqGroups.map((group) => (
                            <div className="faq-group" key={group.title}>
                                <h3 className="faq-group-title">{group.title}</h3>
                                {group.items.map((item, itemIndex) => {
                                    const faqId = `${group.title}-${itemIndex}`;
                                    const isOpen = openFaqId === faqId;

                                    return (
                                        <article className={`faq-item${isOpen ? " is-open" : ""}`} key={item.question}>
                                            <button
                                                type="button"
                                                className="faq-summary"
                                                onClick={() => toggleFaq(faqId)}
                                                aria-expanded={isOpen}
                                            >
                                                <span className="faq-summary-title">{item.question}</span>
                                                <span className="faq-summary-icon" aria-hidden="true" />
                                            </button>
                                            <div className="faq-body" aria-hidden={!isOpen}>
                                                <p>{item.answer}</p>
                                            </div>
                                        </article>
                                    );
                                })}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="cta">
                <div className="cta-inner">
                    <h2>Empezá tu formación en salud hoy</h2>
                    <p>Inscripciones abiertas. Doble titulación FISP | Facultad de Medicina UBA.</p>
                    <div className="cta-btns">
                        <a href="https://wa.me/5491123879118" className="btn-wh">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                            Consultá por WhatsApp
                        </a>
                    </div>
                </div>
            </section>
            <SiteFooter />
        </div>
    );
}
